var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-toolbar-items',{staticClass:"header-responsive"},[_c('v-btn',{staticClass:"header-dialog",attrs:{"icon":""},on:{"click":function($event){return _vm.$emit('open')}}},[_c('v-icon',[_vm._v("menu")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }